import { shareHost } from "./brand";
/* Branded canvas cards: agent day bill (per show qty / amount / win / commission) and a player's booked-ticket photo. */
const rr = (ctx, x, y, w, h, r) => { ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r); ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath(); };
const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");
const t12 = (t) => { if (!t) return ""; const [h, m] = t.split(":").map(Number); return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`; };

function header(ctx, W, title, sub) {
  ctx.fillStyle = "#fde68a"; ctx.font = "900 54px sans-serif"; ctx.textAlign = "left"; ctx.fillText("ROYAL LAKSHMI", 60, 100);
  ctx.fillStyle = "#fff"; ctx.font = "800 36px sans-serif"; ctx.fillText(title, 60, 158);
  ctx.fillStyle = "#cbd5e1"; ctx.font = "600 26px sans-serif"; ctx.fillText(sub, 60, 200);
}
function frame(W, H) {
  const cv = document.createElement("canvas"); cv.width = W; cv.height = H;
  const ctx = cv.getContext("2d");
  const bg = ctx.createLinearGradient(0, 0, 0, H); bg.addColorStop(0, "#1e1b4b"); bg.addColorStop(1, "#0f172a");
  ctx.fillStyle = bg; ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = "#fbbf24"; ctx.lineWidth = 10; rr(ctx, 20, 20, W - 40, H - 40, 36); ctx.stroke();
  return { cv, ctx };
}

/** Agent day bill → PNG dataURL. bill = GET /agent/day-bill */
const GROUP_OF = { A: "single", B: "single", C: "single", ALL: "single", AB: "double", BC: "double", AC: "double", ALL_D: "double", "3D": "3d", "3D_BOX": "3d", "4D": "4d", "4D_BOX": "4d" };
const GROUP_LABEL = { single: "SINGLES", double: "DOUBLES", "3d": "3D", "4d": "4D", other: "OTHER" };
const GROUP_SEQ = ["single", "double", "3d", "4d", "other"];
const boardLabel = (bt) => (bt.endsWith("_BOX") ? "BOX" : bt.startsWith("ALL") ? "ALL" : bt);
const fmtDate = (d) => new Date(d + "T00:00:00").toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });

/** Group a show row's tickets_list → [{id,label,boards:[{label,items:[{number,quantity}]}]}] */
export function groupTickets(list = []) {
  const groups = {};
  for (const t of list) {
    const g = GROUP_OF[t.board_type] || "other";
    const grp = (groups[g] ||= { id: g, label: GROUP_LABEL[g], boards: {} });
    (grp.boards[boardLabel(t.board_type)] ||= []).push(t);
  }
  return GROUP_SEQ.filter((g) => groups[g]).map((g) => ({ ...groups[g], boards: Object.entries(groups[g].boards).map(([label, items]) => ({ label, items })) }));
}

const numQty = (t) => (t.set_qty ? `${t.number}×${t.set_qty} set(×${t.perms || (t.set_boards || []).length}=${t.quantity})` : `${t.number}×${t.quantity}`);

/** WhatsApp text: per show → category → board: number×qty, then totals. */
export function dayBillText(bill) {
  const t = bill.totals || {}, a = bill.agent || {};
  const L = ["👑 ROYAL LAKSHMI — Agent Day Bill", `${a.name || ""} (${a.code || ""}) · ${fmtDate(bill.date)}`, ""];
  if (!bill.rows?.length) L.push("No bookings on this date.", "");
  for (const r of bill.rows || []) {
    L.push(`📌 ${r.game}${r.draw_time ? " · " + t12(r.draw_time) : ""}`);
    for (const g of groupTickets(r.tickets_list)) {
      L.push(`▸ ${g.label}`);
      for (const b of g.boards) L.push(`  ${b.label}: ${b.items.map(numQty).join(", ")}`);
    }
    L.push(`  Show total: qty ${r.tickets} · ${inr(r.amount)}`, "");
  }
  L.push("━━━━━━━━━━━━", `Win ${inr(t.win)} · Comm ${a.commission_rate || 0}% ${inr(t.commission)}`, `✅ NET DUE TO COMPANY: ${inr(t.net_due)}`);
  return L.join("\n");
}

export function renderDayBill(bill) {
  const W = 1080, X0 = 60, LBL = 150, CHIP_H = 46, GAP = 10, rows = bill.rows || [];
  const m = document.createElement("canvas").getContext("2d");
  const ops = []; let y = 300;
  m.font = "800 26px monospace";
  rows.forEach((r) => {
    const hy = y;
    ops.push((c) => { c.fillStyle = "rgba(255,255,255,.10)"; rr(c, 44, hy, W - 88, 56, 14); c.fill(); c.textAlign = "left"; c.fillStyle = "#fff"; c.font = "800 28px sans-serif"; c.fillText(`${r.game}${r.draw_time ? " · " + t12(r.draw_time) : ""}`.slice(0, 36), X0, hy + 38); c.textAlign = "right"; c.fillStyle = "#fde68a"; c.font = "800 24px monospace"; c.fillText(`qty ${r.tickets} · ${inr(r.amount)}`, W - X0, hy + 38); });
    y += 76;
    for (const g of groupTickets(r.tickets_list)) {
      const gy = y;
      ops.push((c) => { c.textAlign = "left"; c.fillStyle = "#fbbf24"; c.font = "900 22px sans-serif"; c.fillText(`▸ ${g.label}`, X0, gy + 20); });
      y += 36;
      for (const b of g.boards) {
        const by = y; let x = X0 + LBL;
        ops.push((c) => { c.textAlign = "left"; c.fillStyle = "#cbd5e1"; c.font = "800 24px sans-serif"; c.fillText(b.label, X0 + 10, by + 32); });
        for (const t of b.items) {
          const txt = numQty(t), w = m.measureText(txt).width + 28;
          if (x + w > W - X0) { x = X0 + LBL; y += CHIP_H + GAP; }
          const cx = x, cy = y;
          ops.push((c) => { c.fillStyle = "rgba(255,255,255,.14)"; rr(c, cx, cy, w, CHIP_H, 10); c.fill(); c.textAlign = "left"; c.fillStyle = "#fff"; c.font = "800 26px monospace"; c.fillText(txt, cx + 14, cy + 32); });
          x += w + GAP;
        }
        y += CHIP_H + GAP + 4;
      }
    }
    y += 22;
  });
  if (!rows.length) { ops.push((c) => { c.textAlign = "center"; c.fillStyle = "#cbd5e1"; c.font = "700 30px sans-serif"; c.fillText("No bookings on this date", W / 2, 340); }); y = 400; }
  const ty = y + 10, H = ty + 300;
  const { cv, ctx } = frame(W, H);
  header(ctx, W, "AGENT DAY BILL", `${bill.agent?.name || ""} · ${bill.agent?.code || ""} · ${bill.agent?.mobile || ""} · ${fmtDate(bill.date)}`);
  ops.forEach((f) => f(ctx));
  const t = bill.totals || {};
  ctx.fillStyle = "rgba(251,191,36,.15)"; rr(ctx, 44, ty, W - 88, 200, 20); ctx.fill();
  ctx.textAlign = "left"; ctx.fillStyle = "#fde68a"; ctx.font = "900 30px sans-serif"; ctx.fillText("TOTAL", 70, ty + 50);
  ctx.fillStyle = "#fff"; ctx.font = "700 26px sans-serif";
  ctx.fillText(`Tickets ${t.tickets || 0} · Bookings ${t.bets || 0} · Amount ${inr(t.amount)}`, 70, ty + 95);
  ctx.fillText(`Win paid ${inr(t.win)}  ·  Commission ${bill.agent?.commission_rate || 0}% ${inr(t.commission)}`, 70, ty + 135);
  ctx.fillStyle = "#4ade80"; ctx.font = "900 34px sans-serif"; ctx.fillText(`Net due to company: ${inr(t.net_due)}`, 70, ty + 182);
  ctx.textAlign = "center"; ctx.fillStyle = "#94a3b8"; ctx.font = "600 20px sans-serif"; ctx.fillText(`Generated ${new Date().toLocaleString("en-IN")} · ${shareHost()}`, W / 2, H - 50);
  return cv.toDataURL("image/png");
}

/** Player's booked ticket photo → PNG dataURL. g = {game, draw_time, draw_date, bets:[{number, box_of, quantity, amount, slat_name, board_type}], total, name, mobile} */
export function renderTicketCard(g) {
  const W = 1080, nums = g.bets || [], ROW = 64, top = 330, H = top + Math.max(1, nums.length) * ROW + 260;
  const { cv, ctx } = frame(W, H);
  header(ctx, W, "MY TICKET", `${g.game} · Draw ${t12(g.draw_time)} · ${new Date((g.draw_date || new Date().toISOString().slice(0, 10)) + "T00:00:00").toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}`);
  ctx.fillStyle = "#94a3b8"; ctx.font = "700 22px sans-serif"; ctx.textAlign = "left"; ctx.fillText("BOARD", 60, 290); ctx.fillText("NUMBER", 400, 290); ctx.textAlign = "right"; ctx.fillText("RATE", 700, 290); ctx.fillText("QTY", 840, 290); ctx.fillText("AMOUNT", 1020, 290);
  nums.forEach((b, i) => {
    const y = top + i * ROW;
    const rate = Number(b.rate || (b.quantity ? (b.amount || 0) / b.quantity / (b.box_size || 1) : 0));
    ctx.fillStyle = i % 2 ? "rgba(255,255,255,.05)" : "rgba(255,255,255,.09)"; rr(ctx, 44, y - 38, W - 88, ROW - 8, 14); ctx.fill();
    ctx.textAlign = "left"; ctx.fillStyle = "#fde68a"; ctx.font = "800 24px sans-serif"; ctx.fillText((b.slat_name || b.board_type || "").slice(0, 18), 60, y + 2);
    ctx.fillStyle = "#fff"; ctx.font = "900 40px monospace"; ctx.fillText(b.box_of ? `BOX ${b.box_of}` : String(b.number), 400, y + 6);
    ctx.textAlign = "right"; ctx.font = "800 26px monospace"; ctx.fillStyle = "#6ee7b7"; ctx.fillText(rate ? inr(rate) : "-", 700, y + 2); ctx.fillStyle = "#fff"; ctx.fillText(String(b.quantity || 1) + (b.box_size > 1 ? `×${b.box_size}` : ""), 840, y + 2); ctx.fillText(inr(b.amount), 1020, y + 2);
  });
  const ty = top + Math.max(1, nums.length) * ROW + 10;
  ctx.fillStyle = "rgba(251,191,36,.15)"; rr(ctx, 44, ty, W - 88, 130, 20); ctx.fill();
  ctx.textAlign = "left"; ctx.fillStyle = "#fff"; ctx.font = "800 28px sans-serif"; ctx.fillText(`${nums.length} ticket${nums.length === 1 ? "" : "s"} · Total ${inr(g.total)}`, 70, ty + 52);
  ctx.fillStyle = "#cbd5e1"; ctx.font = "600 22px sans-serif"; ctx.fillText(`${g.name || ""}${g.mobile ? " · " + String(g.mobile).replace(/(\d{2})\d{6}(\d{2})/, "$1******$2") : ""}`, 70, ty + 95);
  ctx.textAlign = "center"; ctx.fillStyle = "#fbbf24"; ctx.font = "900 30px sans-serif"; ctx.fillText(`Good luck! Result at ${t12(g.draw_time)} · ${shareHost()}`, W / 2, H - 50);
  return cv.toDataURL("image/png");
}

/** Share a dataURL PNG: Web Share (file) → download + optional WhatsApp text. */
export async function sharePng(dataUrl, filename, text, phone) {
  const blob = await (await fetch(dataUrl)).blob();
  const file = new File([blob], filename, { type: "image/png" });
  if (navigator.canShare && navigator.canShare({ files: [file] })) { try { await navigator.share({ files: [file], text }); return "shared"; } catch (e) { if (e?.name === "AbortError") return "cancelled"; } }
  const a = document.createElement("a"); a.href = dataUrl; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
  window.open(`https://wa.me/${phone ? String(phone).replace(/\D/g, "").replace(/^(\d{10})$/, "91$1") : ""}?text=${encodeURIComponent(text)}`, "_blank");
  return "downloaded";
}
